module.exports = __webpack_public_path__ + "img/20200507151208863.79eb363b.png";